import { Injectable } from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {GenerateScheduleRequest} from "../Models/Requests/GenerateScheduleRequest";
import {Observable} from "rxjs";
import {PaymentScheduleHeader} from "../Models/PaymentScheduleHeader";
import {SearchControlNoResponse} from "../Models/iLMS/SearchControlNoResponse";
import {OlamsScheduleDetailsResponse} from "../Models/iLMS/Responses/OlamsScheduleDetailsResponse";
import {PaymentSchedule} from "../Models/PaymentSchedule";
import {SubmittedSchedulesLoanBalanceView} from "../Models/iLMS/Responses/SubmittedSchedulesLoanBalanceView";

@Injectable({
  providedIn: 'root'
})
export class EmployerPaymentService {
  public employer_portal_service_url: string = environment.employer_portal_service_url;
  constructor(private http: HttpClient) { }

  public generateEmployerSchedule(request: GenerateScheduleRequest): Observable<PaymentScheduleHeader> {
    return this.http.post<PaymentScheduleHeader>(`${this.employer_portal_service_url}/employer-payment/generate-employer-schedule/`, request);
  }

  public checkControlNoStatus(bill_id: string): Observable<SearchControlNoResponse> {
    const params: HttpParams = new HttpParams().set('bill_id', bill_id);
    return this.http.get<SearchControlNoResponse>(`${this.employer_portal_service_url}/employer-payment/check-control-no-stat/`, {params})
  }

  public getPaidSchedules(employer_id: number): Observable<PaymentScheduleHeader[]> {
    const params: HttpParams = new HttpParams().set('employer_id', employer_id);
    return this.http.get<PaymentScheduleHeader[]>(`${this.employer_portal_service_url}/employer-payment/paid-schedules/`, {params})
  }

  public getPaymentHeaderSchedules(header_id: number): Observable<PaymentSchedule[]> {
    const params: HttpParams = new HttpParams().set('header_id', header_id);
    return this.http.get<PaymentSchedule[]>(`${this.employer_portal_service_url}/employer-payment/employer-payment-header-schedules/`, {params})
  }

  public getHeaderSubmittedEmployeesBalance(header_id: number): Observable<SubmittedSchedulesLoanBalanceView[]> {
    const params: HttpParams = new HttpParams().set('header_id', header_id);
    return this.http.get<SubmittedSchedulesLoanBalanceView[]>(`${this.employer_portal_service_url}/employer-payment/submitted-schedule-employees-balances/`, {params})
  }

  public getPendingSchedules(employer_id: number): Observable<PaymentScheduleHeader[]> {
    const params: HttpParams = new HttpParams().set('employer_id', employer_id);
    return this.http.get<PaymentScheduleHeader[]>(`${this.employer_portal_service_url}/employer-payment/pending-schedules/`, {params})
  }

  public getEmployerScheduleDetails(header_id: number): Observable<OlamsScheduleDetailsResponse> {
    const params: HttpParams = new HttpParams().set('header_id', header_id);
    return this.http.get<OlamsScheduleDetailsResponse>(`${this.employer_portal_service_url}/employer-payment/employer-schedule-details/`, {params})
  }
}
